import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '../../model/user';
import { Auth2Service } from '../../auth/auth2.service';
import { Subscription } from 'rxjs';
import { Version } from '../../model/version';
import { MessageBellService } from '../../services/message-bell.service';
import { Announces } from 'app/plugin-announce/model/announces';
import { Announce } from 'app/plugin-announce/model/announce';
import { AnnounceService } from 'app/plugin-announce/announce.service';
import { NavigationStateService } from '../navigation/navigation-state.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'topnavbar',
  templateUrl: 'topnavbar.template.html',
  styleUrls: ['./topnavbar.component.css'],
  standalone: false,
})
export class TopNavbarComponent implements OnInit, OnDestroy {
  @Input()
  user: User;

  @Input()
  version: Version;

  announcesSubscription: Subscription;

  announces: Announces;

  constructor(
    private auth2Service: Auth2Service,
    private router: Router,
    private bellService: MessageBellService,
    private announceService: AnnounceService,
    private toastrService: ToastrService,
    public navState: NavigationStateService
  ) {}

  ngOnInit(): void {
    if (this.version.isAuthorized('ANNOUNCE')) {
      this.auth2Service.connected().subscribe((connected) => {
        if (connected) {
          this.announcesSubscription =
            this.bellService.announcesObservable.subscribe((announces) => {
              this.announces = announces;
            });
        }
      });
    }
  }

  ngOnDestroy(): void {
    if (this.announcesSubscription) {
      this.announcesSubscription.unsubscribe();
    }
  }

  impersonateLogout() {
    this.auth2Service.impersonateLogout();
  }

  logout() {
    this.auth2Service.logout();
    this.router.navigate(['/login']);
  }

  markAsRead(n: Announce) {
    this.announceService.markAsRead(n).subscribe(() => {
      this.toastrService.success(n.title, 'Annonce marquée lue');
      this.bellService.reload();
    });
  }

  toggleNavigation(): void {
    document.body.classList.remove('mini-navbar');
    // Desktop : replie/déplie la sidebar aux pictogrammes. Mobile : ouvre/
    // ferme le tiroir existant (comportement inchangé) -- ce sont deux
    // états distincts, la largeur d'écran décide lequel ce bouton pilote.
    if (window.innerWidth >= 768) {
      this.navState.toggleCollapsed();
    } else {
      this.navState.toggleMobile();
    }
  }

  notProd() {
    return this.version.getEnvionment() !== 'PR';
  }
}
